import React from 'react'
import { cn } from '../lib/utils'
import {
 defaultCurrencySymbol,
 formatCurrencyMetricParts,
 type CurrencyMetricParts,
} from '../../helpers/formatMetricDisplay'

type CurrencyAmountProps = {
 value?: number | string | null
 parts?: CurrencyMetricParts
 currencySymbol?: string
 className?: string
 amountClassName?: string
 currencyClassName?: string
 compactCurrency?: boolean
}

/** Amount then currency — correct for RTL (read number first, then ج.م). */
export function CurrencyAmount({
 value,
 parts: partsProp,
 currencySymbol,
 className,
 amountClassName,
 currencyClassName,
 compactCurrency = false,
}: CurrencyAmountProps) {
 const parts = partsProp ?? formatCurrencyMetricParts(value, currencySymbol ?? defaultCurrencySymbol())

 return (
  <span className={cn('inline-flex items-baseline gap-x-1 tabular-nums', className)} title={parts.full}>
   <span
    dir="ltr"
    className={cn('font-inherit', parts.isNegative && 'text-semantic-danger', amountClassName)}
   >
    {parts.amount}
   </span>
   <span
    className={cn(
     compactCurrency
      ? 'shrink-0 text-xs font-semibold leading-none text-muted-foreground sm:text-sm'
      : 'shrink-0 font-normal text-muted-foreground',
     currencyClassName,
    )}
   >
    {parts.currency}
   </span>
  </span>
 )
}
